const ITEMS = [
  "Custom Software",
  "SaaS Platforms",
  "School Management ERP",
  "Mobile Apps",
  "AI & Automation",
  "E-Commerce",
  "UI/UX Design",
  "Digital Consultancy",
];

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-white/10 bg-navy py-5" data-testid="editorial-marquee" aria-hidden="true">
    <div className="animate-marquee flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {ITEMS.map((item, i) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className={`whitespace-nowrap font-jakarta text-lg font-bold tracking-tight sm:text-xl ${i % 2 === 0 ? "text-white/90" : "text-stroke-gold"}`}>
                {item}
              </span>
              <span className="mx-7 h-1.5 w-1.5 rotate-45 bg-magenta/80" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
